import { useQuery } from '@tanstack/react-query'
import { IQuestionnairesResponse } from '~api/vessels/read'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export function useGetQuestionnaires(vesselId: string | undefined) {
  const fetchRequest = useFetch<IQuestionnairesResponse>()
  return useQuery({
    queryKey: [`/vessels/${vesselId}/questionnaire`],
    queryFn: () =>
      fetchRequest(`${apiBase()}/vessels/${vesselId}/questionnaire`),
    enabled: !!vesselId,
  })
}
